import { Button } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import left from '../../../assets/icons/left.svg';
import nextPage from '../../../assets/icons/next_page.svg';

const ServiceHeader = ({ service, setType, openApplication }) => {
  const { t } = useTranslation();

  return (
    <div className="title-detail-service-component">
      <span>
        <img
          onClick={() => setType(0)}
          style={{ cursor: 'pointer', marginRight: '10px' }}
          src={left}
          alt="left"
        />
        {service && service.name}
      </span>
      <Button
        type="primary"
        style={{ marginLeft: 'auto' }}
        onClick={openApplication}
        disabled={!service}
      >
        <img style={{ marginRight: '10px' }} src={nextPage} alt="next-page" />
        {t('Open Application')}
      </Button>
    </div>
  );
};

export default ServiceHeader;
